// This file is required for Expo/React Native SQLite migrations - https://orm.drizzle.team/quick-sqlite/expo

import m0000 from "./0000_harsh_shiva.sql"
import m0001 from "./0001_bored_hobgoblin.sql"
import m0002 from "./0002_smart_power_man.sql"
import m0003 from "./0003_known_roland_deschain.sql"
import m0004 from "./0004_majestic_thunderbolt_ross.sql"
import m0005 from "./0005_tense_sleepwalker.sql"
import m0006 from "./0006_exotic_kid_colt.sql"
import m0007 from "./0007_curvy_tarantula.sql"
import m0008 from "./0008_last_the_santerians.sql"
import m0009 from "./0009_lucky_power_man.sql"
import m0010 from "./0010_legal_ben_grimm.sql"
import m0011 from "./0011_mysterious_stark_industries.sql"
import m0012 from "./0012_magenta_thing.sql"
import m0013 from "./0013_chunky_stephen_strange.sql"
import m0014 from "./0014_chemical_shocker.sql"
import m0015 from "./0015_colorful_warbird.sql"
import m0016 from "./0016_curious_carnage.sql"
import m0017 from "./0017_talented_captain_cross.sql"
import m0018 from "./0018_dashing_the_fury.sql"
import m0019 from "./0019_wonderful_shape.sql"
import m0020 from "./0020_little_marauders.sql"
import m0021 from "./0021_wakeful_onslaught.sql"
import m0022 from "./0022_tiny_northstar.sql"
import m0023 from "./0023_pink_namor.sql"
import m0024 from "./0024_spooky_alex_power.sql"
import m0025 from "./0025_colorful_valkyrie.sql"
import m0026 from "./0026_numerous_slyde.sql"
import m0027 from "./0027_nostalgic_human_torch.sql"
import m0028 from "./0028_chief_cyclops.sql"
import m0029 from "./0029_flaky_gorgon.sql"
import m0030 from "./0030_common_gabe_jones.sql"
import m0031 from "./0031_kind_ikaris.sql"
import m0032 from "./0032_orange_prima.sql"
import m0033 from "./0033_shiny_sebastian_shaw.sql"
import m0034 from "./0034_curly_darkstar.sql"
import m0035 from "./0035_last_valeria_richards.sql"
import m0036 from "./0036_entry_tag_summary.sql"
import m0037 from "./0037_bored_the_leader.sql"
import m0038 from "./0038_sync_transactions.sql"
import m0039 from "./0039_sync_meta.sql"
import m0040 from "./0040_sync_transaction_owner.sql"
import journal from "./meta/_journal.json"

export default {
  journal,
  migrations: {
    m0000,
    m0001,
    m0002,
    m0003,
    m0004,
    m0005,
    m0006,
    m0007,
    m0008,
    m0009,
    m0010,
    m0011,
    m0012,
    m0013,
    m0014,
    m0015,
    m0016,
    m0017,
    m0018,
    m0019,
    m0020,
    m0021,
    m0022,
    m0023,
    m0024,
    m0025,
    m0026,
    m0027,
    m0028,
    m0029,
    m0030,
    m0031,
    m0032,
    m0033,
    m0034,
    m0035,
    m0036,
    m0037,
    m0038,
    m0039,
    m0040,
  },
}
